import { createContext, useContext } from "react";

export const AutosaveReportContext = createContext({
  triggerAutosave: async () => {},
});

export const useAutosaveReportContext = () => useContext(AutosaveReportContext);
